document.addEventListener("DOMContentLoaded", function() {
    // 1. Seleccionamos todos los enlaces dentro del contenedor del footer
    const footerLinks = document.querySelectorAll('.m-footer--accordion a.m-link');

    // 2. Recorremos cada enlace
    footerLinks.forEach(link => {
    // .trim() elimina espacios en blanco extras al inicio o final del texto
    if (link.textContent.trim() === "Libro de reclamaciones") {
        
        // 3. Añadimos la clase deseada
        link.classList.add('claim-book-footer');
        
        // Opcional: imprimir en consola para confirmar que lo encontró
        console.log("Clase añadida al Libro de Reclamaciones");
    }
    });
});